// extracted by mini-css-extract-plugin
export var overview_content_wrap = "style-module--overview_content_wrap--885c9";
export var overview_image_wrap = "style-module--overview_image_wrap--7c437";
export var overview_info_wrap = "style-module--overview_info_wrap--8a4fd";
export var overview_title = "style-module--overview_title--c808b";